import { render } from "./_autocomplete-tips.vue?vue&type=template&id=47dacd26&lang=pug"
import script from "./_autocomplete-tips.vue?vue&type=script&lang=js"
export * from "./_autocomplete-tips.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__